// FILECONTENT_START src/common/layouts/HeaderSidebarContent/index.ts
import HeaderSideBarContent from "./HeaderSideBarContent";
export default HeaderSideBarContent;

// FILECONTENT_END src/common/layouts/HeaderSidebarContent/index.ts